import { render } from "./CaseItems.vue?vue&type=template&id=1a4733fe&scoped=true"
import script from "./CaseItems.vue?vue&type=script&lang=js"
export * from "./CaseItems.vue?vue&type=script&lang=js"

import "./CaseItems.vue?vue&type=style&index=0&id=1a4733fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4733fe"]])

export default __exports__